import React, { Component } from "react";
import { HashRouter as Router, Route, Switch } from "react-router-dom";
import "whatwg-fetch";

import Schools from "./routes/Schools";
import Asbestos from "./routes/Asbestos";
import Asthma from "./routes/Asthma";
import Lead from "./routes/Lead";
import LeadWater from "./routes/LeadWater";
import About from "./routes/About";
import ToxicHeader from "./components/ToxicHeader";
import Home from "./routes/Home";
import Footer from "./components/Footer";
import ScrollToTop from "./components/scrollToTop";

// data
// import data from './data/schools.json';
// import chartdata from './data/chartsdata.json';

import "./css/App.css";

class App extends Component {
  render() {
    return (
      <Router hashType={"noslash"}>
        <ScrollToTop>
          <div>
            <ToxicHeader />
            <div className="container main">
              <Switch>
                <Route
                  path="/schools"
                  render={props => (
                    <Schools
                      data={this.props.data}
                      asbestos={this.props.asbestos}
                      asbestos2020={this.props.asbestos2020}
                      water={this.props.water}
                      reports={this.props.reports}
                      food={this.props.food}
                      testdata={this.props.testdata}
                      {...props}
                    />
                  )}
                />
                <Route path="/about" component={About} />
                <Route
                  path="/asbestos"
                  render={() => (
                    <Asbestos
                      data={this.props.data}
                      testdata={this.props.testdata.asbestos}
                      updatedata={this.props.testdata.asbestos2020}
                    />
                  )}
                />
                <Route
                  path="/asthma-triggers"
                  render={() => (
                    <Asthma
                      data={this.props.data}
                      testdata={this.props.testdata.asthma}
                    />
                  )}
                />
                <Route
                  path="/lead-paint-residue"
                  render={() => (
                    <Lead
                      data={this.props.data}
                      testdata={this.props.testdata.lead}
                    />
                  )}
                />
                <Route
                  path="/lead-water"
                  render={() => (
                    <LeadWater
                      data={this.props.data}
                      testdata={this.props.testdata.water}
                    />
                  )}
                />
                <Route
                  exact
                  path="/"
                  render={props => <Home data={this.props.data} {...props} />}
                />
              </Switch>
            </div>
            <Footer />
          </div>
        </ScrollToTop>
      </Router>
    );
  }
}

export default App;



// WEBPACK FOOTER //
// ./src/App.js